import { render, staticRenderFns } from "./userActivity.vue?vue&type=template&id=1c59327c&scoped=true"
import script from "./userActivity.vue?vue&type=script&lang=js"
export * from "./userActivity.vue?vue&type=script&lang=js"
import style0 from "./userActivity.vue?vue&type=style&index=0&id=1c59327c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c59327c",
  null
  
)

export default component.exports